
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.2324 11.0812C20.2045 10.9603 20.1471 10.8482 20.0653 10.7549C19.9835 10.6617 19.8799 10.5902 19.7636 10.5468L14.3636 8.52181L15.7324 1.64994C15.7638 1.49076 15.7435 1.32568 15.6743 1.1789C15.6052 1.03212 15.4908 0.91136 15.348 0.834313C15.2038 0.7576 15.0382 0.730716 14.8772 0.757845C14.7161 0.784975 14.5685 0.864595 14.4574 0.984313L3.95737 12.2343C3.87133 12.3236 3.80908 12.433 3.77632 12.5526C3.74356 12.6722 3.74135 12.798 3.76987 12.9187C3.79922 13.0389 3.85716 13.1503 3.93877 13.2433C4.02038 13.3363 4.12324 13.4083 4.23862 13.4531L9.63862 15.4781L8.26987 22.3499C8.23839 22.5091 8.25873 22.6742 8.3279 22.821C8.39707 22.9678 8.51144 23.0885 8.65424 23.1656C8.76189 23.2199 8.88056 23.2487 9.00112 23.2499C9.103 23.2504 9.20388 23.2298 9.29744 23.1895C9.391 23.1491 9.47523 23.0899 9.54487 23.0156L20.0449 11.7656C20.1309 11.6763 20.1932 11.5669 20.2259 11.4473C20.2587 11.3277 20.2609 11.2018 20.2324 11.0812Z","fill":"#EE7F1A"}})])
          )
        }
      }
    